import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index.js';
Vue.use(VueRouter);
const constantRoutes = [{
  path: '/',
  redirect: '/homepage',
  hidden: true
}, {
  path: '/404',
  name: '404',
  component: () => import('@/views/404/index.vue'),
  hidden: true
}, {
  path: '/login',
  name: 'login',
  component: () => import('@/views/login/index.vue'),
  meta: {
    title: '登录'
  }
}, {
  path: '/agreement',
  name: 'agreement',
  component: () => import('@/views/agreement/index.vue'),
  meta: {
    title: '用户协议'
  }
}, {
  path: '/homepage',
  name: 'homepage',
  component: () => import('@/views/homepage/index.vue'),
  meta: {
    title: '首页'
  }
}, {
  path: '/service/self-select-stock',
  name: 'self-select-stock',
  component: () => import('@/views/service/self-select-stock/index.vue'),
  meta: {
    title: '自选股同步'
  }
}, {
  path: '/service/phone-oem',
  name: 'phone-oem',
  component: () => import('@/views/service/phone-oem/index.vue'),
  meta: {
    title: '移动金融终端'
  }
}, {
  path: '/service/investment-research',
  name: 'investment-research',
  component: () => import('@/views/service/investment-research/index.vue'),
  meta: {
    title: '智能投研'
  }
}, {
  path: '/service/big-data',
  name: 'big-data',
  component: () => import('@/views/service/BigData/index.vue'),
  meta: {
    title: '大数据'
  }
}, {
  path: '/service/investment-advisor',
  name: 'investment-advisor',
  component: () => import('@/views/service/investment-advisor/index.vue'),
  meta: {
    title: '人工投顾'
  }
}, {
  path: '/service/operating-activities',
  name: 'operating-activities',
  component: () => import('@/views/service/operating-activities/index.vue'),
  meta: {
    title: '活动运营中台'
  }
}, {
  path: '/service/sailing-version',
  name: 'sailing-version',
  component: () => import('@/views/service/sailing-version/index.vue'),
  meta: {
    title: '远航版'
  }
}, {
  path: '/service/financial-terminal',
  name: 'financial-terminal',
  component: () => import('@/views/service/FinancialTerminal/index.vue'),
  meta: {
    title: '金融终端2.0'
  }
}, {
  path: '/service/mac-version',
  name: 'mac-version',
  component: () => import('@/views/service/mac-version/index.vue'),
  meta: {
    title: 'Mac版'
  }
}, {
  path: '/service/institutional-trading',
  name: 'institutional-trading',
  component: () => import('@/views/service/institutional-trading/index.vue'),
  meta: {
    title: '机构交易版'
  }
}, {
  path: '/service/openAI',
  name: 'openAI',
  component: () => import('@/views/service/openAI/index.vue'),
  meta: {
    title: 'OPENAI'
  }
}, {
  path: '/service/personal',
  name: 'personal',
  component: () => import('@/views/service/PersonalCenter/index.vue'),
  meta: {
    title: 'PENSONAL'
  }
}, {
  path: '/service/details',
  name: 'details',
  component: () => import('@/views/service/ComponentDetails/index.vue'),
  meta: {
    title: 'COMPONENT'
  }
}, {
  path: '/service/check',
  name: 'check',
  component: () => import('@/views/service/CheckPage/index.vue'),
  meta: {
    title: 'CKECK'
  }
}, {
  path: '/news',
  name: 'news',
  component: () => import('@/views/news/index.vue'),
  meta: {
    title: '新闻动态'
  }
}, {
  path: '/skillmarket',
  redirect: '/service/skillmarket'
}, {
  path: '/service/skillmarket',
  name: 'SkillMarket',
  component: () => import('@/views/technology/SkillMarket/index.vue'),
  meta: {
    title: 'Skill市场'
  }
}, {
  path: '/service/tokenhub',
  name: 'TokenHub',
  component: () => import('@/views/hub/TokenHub/index.vue'),
  meta: {
    title: 'Token Hub'
  }
}, {
  path: '/aboutUS',
  name: 'aboutUS',
  component: () => import('@/views/aboutUS/index.vue'),
  meta: {
    title: '公司介绍'
  }
},
// 新增组件路由
{
  path: '/service/Information',
  name: 'Information',
  component: () => import('@/views/service/Information/index.vue'),
  meta: {
    title: '资讯'
  }
}, {
  path: '/service/CustomerServiceBot',
  name: 'CustomerServiceBot',
  component: () => import('@/views/service/CustomerServiceBot/index.vue'),
  meta: {
    title: '客服机器人'
  }
}, {
  path: '/service/OutboundCallingBot',
  name: 'OutboundCallingBot',
  component: () => import('@/views/service/OutboundCallingBot/index.vue'),
  meta: {
    title: '智能外呼'
  }
}, {
  path: '/service/CallQualityInspection',
  name: 'CallQualityInspection',
  component: () => import('@/views/service/CallQualityInspection/index.vue'),
  meta: {
    title: '智能质检'
  }
}, {
  path: '/service/OnlineSupport',
  name: 'OnlineSupport',
  component: () => import('@/views/service/OnlineSupport/index.vue'),
  meta: {
    title: '智能客服'
  }
}, {
  path: '/service/Vtuber',
  name: 'Vtuber',
  component: () => import('@/views/service/Vtuber/index.vue'),
  meta: {
    title: '虚拟人'
  }
}, {
  path: '/service/IntelligentInvestmentAssistant',
  name: 'IntelligentInvestmentAssistant',
  component: () => import('@/views/service/IntelligentInvestmentAssistant/index.vue'),
  meta: {
    title: '智能投资助理'
  }
}, {
  path: '/service/ShortsPlatform',
  name: 'ShortsPlatform',
  component: () => import('@/views/service/ShortsPlatform/index.vue'),
  meta: {
    title: '短视频平台'
  }
}, {
  path: '/technology/TextToSpeech',
  name: 'TextToSpeech',
  component: () => import('@/views/technology/TextToSpeech/index.vue'),
  meta: {
    title: '语音合成'
  }
}, {
  path: '/technology/AiWriter',
  name: 'AiWriter',
  component: () => import('@/views/technology/AiWriter/index.vue'),
  meta: {
    title: '自动写文章'
  }
}, {
  path: '/technology/FinancialTextReview',
  name: 'FinancialTextReview',
  component: () => import('@/views/technology/FinancialTextReview/index.vue'),
  meta: {
    title: '金融文本审核'
  }
}, {
  path: '/technology/ContractComparison',
  name: 'ContractComparison',
  component: () => import('@/views/technology/ContractComparison/index.vue'),
  meta: {
    title: '合同文档对比'
  }
}, {
  path: '/technology/TextTranslation',
  name: 'TextTranslation',
  component: () => import('@/views/technology/TextTranslation/index.vue'),
  meta: {
    title: '文本翻译'
  }
}, {
  path: '/technology/FaceRecognition',
  name: 'FaceRecognition',
  component: () => import('@/views/technology/FaceRecognition/index.vue'),
  meta: {
    title: '摄像头人脸识别'
  }
}, {
  path: '/solution/SecuritiesSolutions',
  name: 'SecuritiesSolutions',
  component: () => import('@/views/solution/SecuritiesSolutions/index.vue'),
  meta: {
    title: '证券解决方案'
  }
}, {
  path: '/solution/HealthcareSolutions',
  name: 'HealthcareSolutions',
  component: () => import('@/views/solution/HealthcareSolutions/index.vue'),
  meta: {
    title: '医疗解决方案'
  }
}, {
  path: '/service/financial-terminal-manual',
  name: 'financial-terminal-manual',
  component: () => import('@/views/service/financial-terminal-manual/index.vue'),
  meta: {
    title: '金融终端2.0操作手册'
  }
}, {
  path: '*',
  redirect: '/404',
  hidden: true
}];
const createRouter = () => new VueRouter({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
});
const router = createRouter();

// reset router
export const resetRouter = () => {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
};
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('personal') !== -1 || to.path.indexOf('details') !== -1) {
    if (store.getters.haslogin) {
      next();
    } else {
      _message.warning('请登录后查看');
      next('/login');
    }
  } else {
    next();
  }
});

// hack router push callback
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
export default router;